import {Context} from '@nuxt/types';
import initializeApi from '~/lib/accessors/api';


export default function (ctx: Context) {
  initializeApi(ctx);
}
